import React, { Fragment } from "react";

import { connect } from "react-redux";

import { Add_Jobdesk } from "../../../../../../Store/Actions/Jobdesk.Action";

import { Skeleton, Button, } from "@mui/material";

import CustomInputForm from "../../../../../Containers/CustomInputForm";

class Jobdesk extends React.Component {
  state = {
    NamaJabatan: "",
    JobdeskDocument: '',
  };

  componentDidMount() {
    const { MPPSelectDetail } = this.props;

    this.setState({
      NamaJabatan: `${MPPSelectDetail?.DepNama ? MPPSelectDetail.DepNama : ""
        } - ${MPPSelectDetail?.LevNama ? MPPSelectDetail.LevNama : ""} ${MPPSelectDetail?.Sub ? MPPSelectDetail.Sub : ""
        }`,
    })
  }

  File_OnChange = E => {
    this.setState({ [E.target.name]: E.target.files[0] })
  }

  formOnSubmit = (Status) => {
    const { MPPSelectDetail } = this.props;

    this.props.Add_Jobdesk(
      MPPSelectDetail.Id,
      this.state.NamaJabatan,
      MPPSelectDetail.MPPListId,
      MPPSelectDetail.LevelId,
      MPPSelectDetail.DepartemenId,
      MPPSelectDetail.StatusKaryawan,
      this.state.JobdeskDocument,
      Status,
    );
  };

  render() {

    const {
      NamaJabatan,
      JobdeskDocument
    } = this.state

    const DataForm = [
      {
        Label: `Job Description File Upload Untu ${NamaJabatan} (pdf max 500kb)`,
        Type: 'Document',
        Name: 'JobdeskDocument',
        Value: JobdeskDocument,
        Action: this.File_OnChange,
        isRequired: true,
      },
    ]
    return (
      <Fragment>
        {false ? (
          <Fragment>
            {[1, 2, 3, 4, 5, 6, 7].map((item) => (
              <Skeleton height={"8vh"} key={`PRForm_Skeleton_${item} `} />
            ))}
          </Fragment>
        ) : (
          <Fragment>
            <CustomInputForm
              DataForm={DataForm}
            />
            <center>
              <Button
                variant="contained"
                style={{ width: "60%", margin: "2% 0 5% 0" }}
                disabled={JobdeskDocument ? false : true}
                onClick={() => this.formOnSubmit(true)}
              >
                Save
              </Button>
            </center>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  User: state.Auth.User,
  // isPRAddLoading: state.PR.isPRAddLoading,
  isJobdeskGetMasterUserLoading: state.Jobdesk.isJobdeskGetPertanyaanLoading,
  JobdeskGetMasterUser: state.Jobdesk.JobdeskGetMasterUser,
  isJobdeskActionGetDataLoading: state.Jobdesk.isJobdeskActionGetDataLoading,
  JobdeskData: state.Jobdesk.JobdeskData,
  // JobdeskListPrilaku: state.Jobdesk.JobdeskListPrilaku,
  JobdeskListTeknik: state.Jobdesk.JobdeskListTeknik,
  // MPPDetail: state.MPP.MPPDetail,
  // MPPList: state.MPP.MPPList,
  // MPPListItem: state.MPP.MPPListItem,
});

export default connect(mapStateToProps, { Add_Jobdesk, })(Jobdesk);
